import ImageKit from 'components/Image';
import { useNavigate } from 'react-router-dom';
import './ActionBar.scss';

export default function ActionBar({ title, arrow, icon, isDark, scroll, onClick, logo, divider }) {
	const navigate = useNavigate();

	return (
		<section
			id="action-bar"
			className={isDark ? 'dark-action-bar' : ''}
			style={{ borderBottom: divider ? '2px solid #DBDBDB' : '' }}
		>
			<section onClick={() => navigate(-1, { replace: true })} {...(onClick && { onClick })}>
				{arrow && (
					<i
						className={scroll || isDark ? `action-bar-scroll ${arrow} ` : `dark-action-bar ${arrow}`}
						id="back-btn"
					></i>
				)}
				<h5 className={scroll || isDark ? `action-bar-scroll` : `dark-action-bar`}>{title}</h5>
			</section>
			{icon && <i className={icon} id={scroll ? 'color-black' : 'color-white'}></i>}

			{logo && scroll && (
				<ImageKit
					loading="lazy"
					src={logo}
					alt="logo"
					width={35}
					height={35}
					style={{ objectFit: 'contain' }}
				/>
			)}
		</section>
	);
}
